export const deleteDesigns = (designs) => {
    const url = global.config.server_path+'saved_design/delete'
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', 'body': JSON.stringify({id: designs})})
    .then(data => {
        return Promise.resolve('Success')
    })
    .catch(err => Promise.reject(err))
}


export const moveDesignsToFolder = (folder_id, designs) => {
    const url = global.config.server_path+'saved_design/move_to_folder'
    return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', 'body': JSON.stringify({folder_id: folder_id, design_id : designs})})
    .then(data => {
        return Promise.resolve('Success')
    })
    .catch(err => Promise.reject(err))
}